var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 76,
    viewBox: "0 0 62 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.6122 51.013L43.3933 51.7896L43.3875 51.7937L42.8402 53.7629C42.8405 53.7675 42.8394 53.7721 42.8371 53.7762C42.8349 53.7804 42.8314 53.7841 42.827 53.787L38.3272 69.8951L38.3314 69.8999C38.3311 69.9047 38.3287 69.9088 38.3248 69.9123L38.008 71.05L43.6238 67.2874L43.608 51.6536H43.6138L43.6122 51.013Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7207 26.9743L48.9048 28.283C48.9027 28.292 48.8982 28.3004 48.8916 28.3077L28.9632 60.29C28.9568 60.2974 28.9523 60.3059 28.9499 60.3147L28.5047 61.0261L28.3936 61.2101L49.7381 46.9104L49.7207 27.7461V26.9743Z",
    fill: "#E5A1F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4416 0.3703L56.0577 2.0182V2.02712C56.0577 2.02712 56.0528 2.02232 56.0519 2.03056C56.0465 2.03532 56.0423 2.04092 56.0395 2.04704L56.0279 2.05459C56.0159 2.06536 56.0056 2.07736 55.9972 2.09029L56.0022 2.0951C55.9876 2.11485 55.9712 2.13367 55.9533 2.1514L18.3808 47.0436L18.3634 47.0546L18.3153 47.1109L16.9481 48.7498L16.6164 49.1515L57.4606 21.7888L57.4424 2.58535C57.4397 2.5782 57.4397 2.57053 57.4424 2.56338L57.4416 0.3703Z",
    fill: "#803BEC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4418 0.3703L3.96234 36.1963L16.6175 49.1515L16.9492 48.7498L18.3164 47.1109L18.3645 47.0546L18.3819 47.0436L55.9494 2.15415C55.9673 2.13641 55.9837 2.11759 55.9983 2.09785L55.9933 2.09304C56.0016 2.08011 56.012 2.06811 56.024 2.05734L56.0356 2.04978C56.0383 2.04366 56.0426 2.03806 56.048 2.0333C56.048 2.02506 56.0538 2.02987 56.0538 2.02987V2.02094L57.4418 0.3703Z",
    fill: "#803BEC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7206 26.9743L16.6164 49.1523L28.3902 61.2087L28.5013 61.0247L28.9457 60.3154C28.9481 60.3065 28.9526 60.2981 28.959 60.2907L48.8873 28.3084C48.894 28.3011 48.8985 28.2926 48.9006 28.2837L49.7206 26.9743Z",
    fill: "#E5A1F8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6124 51.013L28.3944 61.208L38.0124 71.05L38.3291 69.9123C38.3331 69.9088 38.3355 69.9047 38.3358 69.8999L38.3316 69.8951L42.8538 53.7334L43.3977 51.7896L43.6124 51.013Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4416 2.58539C57.3164 4.17836 57.2492 5.76377 57.1763 7.35333C57.0809 8.95728 57.032 10.5619 56.9731 12.1652L56.8471 16.9791L56.7783 21.5143L53.1707 23.8996C51.883 24.7551 50.6004 25.6059 49.3218 26.4703C46.7764 28.1917 44.2243 29.9165 41.7004 31.6701C40.4318 32.5353 39.1715 33.4183 37.917 34.2978C36.6625 35.1774 35.4064 36.0652 34.161 36.9537C32.9157 37.8422 31.6736 38.7444 30.4374 39.6432C29.2011 40.542 27.9591 41.4428 26.7402 42.3684C28.0876 41.5747 29.4067 40.761 30.7359 39.9487C32.065 39.1365 33.3783 38.3263 34.6892 37.4948C36.0001 36.6632 37.3043 35.8469 38.606 35.003C39.9078 34.1591 41.217 33.3393 42.503 32.4927C44.6488 31.1023 46.7863 29.6933 48.9031 28.283C49.1519 28.1155 49.4006 27.9569 49.6493 27.7934L49.7231 27.744V26.9743L57.4631 21.7889L57.4416 2.58539Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.721 26.9743C49.6911 27.249 49.6667 27.522 49.648 27.7934C49.517 29.188 49.4333 30.5743 49.3503 31.9606C49.2633 33.6215 49.1845 35.2831 49.1356 36.9434C49.0867 38.6037 49.0526 40.2646 49.0302 41.9228C49.0302 43.4876 48.9938 45.0586 49.0121 46.6262C47.7377 47.4948 46.4417 48.3537 45.1889 49.2415C43.8274 50.1849 42.471 51.1242 41.1327 52.091C39.7862 53.0399 38.4628 54.0136 37.1329 54.9879C35.8187 55.9697 34.4988 56.9551 33.2211 57.9747C34.687 57.1507 36.1231 56.2849 37.5608 55.4253C38.9911 54.5526 40.4155 53.684 41.8176 52.7914C42.3425 52.4632 42.8723 52.1315 43.388 51.7937L43.3938 51.7896C43.4356 51.7718 43.4737 51.7487 43.5066 51.7209C43.5448 51.7027 43.5792 51.6796 43.6085 51.6523H43.6144V51.0151L49.7409 46.9104L49.7234 27.7461L49.721 26.9743Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6122 51.013C43.5716 51.2506 43.5359 51.484 43.5061 51.7223C43.3402 52.8429 43.2308 53.96 43.1446 55.0867C43.0393 56.4408 42.9787 57.7982 42.9373 59.1536C42.9033 59.8306 42.9157 60.5069 42.9016 61.1853C42.8875 61.8637 42.8951 62.5435 42.9075 63.2198C42.9199 63.8961 42.9075 64.5786 42.9432 65.257C42.9747 65.866 42.9903 66.4778 43.026 67.0834C42.1968 67.6911 41.3793 68.3029 40.5833 68.9298C39.7103 69.6232 38.8422 70.3167 38.0064 71.0527L43.6222 67.2901L43.6064 51.6564H43.6122V51.013Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5235 5.00366L3.96234 36.1963L33.4896 66.4229C31.8737 64.6342 30.2195 62.8641 28.5712 61.0899L28.5065 61.0212L26.3508 58.6997L22.7531 54.8629L19.1356 51.0356L17.0553 48.8583L16.95 48.7499L11.8499 43.4141L4.96807 36.2883C8.67156 33.821 12.3668 31.343 16.0537 28.8543C19.9316 26.2561 23.7788 23.6166 27.6343 20.9951L33.3943 17.0347L39.1319 13.0522L44.8422 9.04029C46.7459 7.70549 48.6364 6.36112 50.5235 5.00366Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4063 52.4659C43.3706 52.5448 43.1576 53.0152 42.8408 53.7629C42.8412 53.7675 42.8401 53.772 42.8378 53.7762C42.8354 53.7804 42.8319 53.7841 42.8276 53.7869L38.3278 69.8951V69.9122C38.3318 69.9088 38.3341 69.9047 38.3345 69.8999C38.3917 69.7756 38.8593 68.7547 39.4256 67.2468C39.7365 66.4401 40.0748 65.4973 40.4065 64.4818C40.7381 63.4663 41.0748 62.3766 41.4056 61.2917C41.7066 60.1931 42.0225 59.1055 42.2729 58.0735C42.5233 57.0415 42.7563 56.0775 42.9255 55.2405C43.2522 53.6737 43.3972 52.5805 43.4063 52.4659Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8915 28.3076L28.9631 60.2899C28.9567 60.2973 28.9523 60.3057 28.9499 60.3146C28.9499 60.3146 29.3022 59.8292 29.8992 58.9784C30.4962 58.1277 31.3577 56.9041 32.346 55.4251C33.3343 53.9462 34.4893 52.2234 35.6924 50.3592C36.8955 48.4951 38.1525 46.5018 39.4153 44.5051C40.6523 42.5015 41.8944 40.4945 43.0195 38.6001C44.1447 36.7057 45.1944 34.9411 46.0649 33.4085C46.9355 31.876 47.6403 30.5934 48.1378 29.7008C48.5747 28.9167 48.8301 28.4182 48.8915 28.3076Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5237 4.01137C55.2575 3.06108 55.7558 2.41634 55.9498 2.15405L18.3807 47.0435C18.5631 46.8375 19.1477 46.203 20.0307 45.2219C21.0937 44.012 22.6624 42.3003 24.4716 40.2095C26.2808 38.1187 28.4166 35.6991 30.6578 33.0686C32.899 30.4382 35.272 27.636 37.6408 24.8202C39.9889 22.005 42.3428 19.1803 44.511 16.512C46.6983 13.8569 48.6866 11.3425 50.417 9.21049C52.1474 7.07852 53.5279 5.26171 54.5237 4.01137Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.25
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0249 2.05731C56.0128 2.06829 56.0025 2.08051 55.994 2.09368L55.999 2.09858C56.0091 2.08548 56.0177 2.07168 56.0249 2.05731Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M38.332 69.9001L38.3278 69.8951V69.9131C38.3309 69.9095 38.3324 69.9052 38.332 69.9001Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8492 53.7333C42.6958 54.124 42.5059 54.5937 42.3086 55.1224C42.0035 55.9257 41.6652 56.8678 41.3335 57.884C41.0019 58.9002 40.6652 59.9892 40.3385 61.0782C40.0268 62.1768 39.7175 63.2602 39.4663 64.2922C39.2151 65.3242 38.9879 66.2931 38.8138 67.1253C38.4821 68.6832 38.342 69.7674 38.3262 69.8951L42.8492 53.7333Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9018 28.283C48.9018 28.283 48.5445 28.7637 47.9525 29.6192C47.3605 30.4747 46.4932 31.6935 45.5007 33.1677C44.5082 34.6418 43.3624 36.3742 42.1585 38.2384C40.9545 40.1026 39.6943 42.091 38.4365 44.0925C37.1994 46.0961 35.9623 48.0997 34.833 49.992C33.7037 51.8843 32.6565 53.6593 31.7859 55.1918C30.9153 56.7244 30.2106 58.007 29.7131 58.8934C29.2803 59.681 29.0241 60.1794 28.9669 60.29L48.8952 28.3077C48.8995 28.3 48.9018 28.2915 48.9018 28.283Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0246 2.05731C56.0126 2.06809 56.0023 2.08009 55.9939 2.09302C55.8074 2.299 55.2336 2.93001 54.3498 3.91051C53.2818 5.11554 51.7181 6.83279 49.9089 8.92284C48.0997 11.0129 45.9639 13.4333 43.7177 16.0582C41.4716 18.6832 39.1085 21.4949 36.7355 24.3067C34.3916 27.1294 32.0376 29.9507 29.8694 32.6148C27.6822 35.2707 25.6947 37.7844 23.9635 39.9164C22.2322 42.0483 20.8526 43.8679 19.8568 45.1182C19.0036 46.2264 18.4588 46.9186 18.3403 47.0758C18.3506 47.0698 18.3586 47.0614 18.3635 47.0518L18.3809 47.0408L55.9492 2.15413C55.9672 2.13639 55.9835 2.11757 55.9981 2.09782C56.0084 2.085 56.0173 2.07144 56.0246 2.05731Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di",
    x: 0.242212,
    y: 0.3703,
    width: 60.9411,
    height: 78.1227,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.72013
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.86006
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.58019,
    dy: 3.72013
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.86006
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ecb09118c602d997da81e3e8f08336b3.svg";
export { ForwardRef as ReactComponent };